<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>质量监控</el-breadcrumb-item>
			<el-breadcrumb-item>视频监控</el-breadcrumb-item>
		</el-breadcrumb>
		<tool-bar v-on:select="handleSelectJT" :timerVisible="false" />
		<div></div>
		<div id="divPlugin" class="plugin"></div>
	</div>
</template>
<script>
	import { WebVideoCtrl } from '../../../static/webVideoCtrl.js'
	import { workshopRequest } from '@/network/requests/workshop'
	import ToolBar from './ToolBar'
	export default {
		name: 'videoew',
		components: {
			ToolBar,
		},
		data() {
			return {
				hkvInfo: {
					ip: '', //海康威视摄像头/硬盘录像机的ip地址
					port: '80', //海康威视摄像头/硬盘录像机的端口
					username: 'admin', //海康威视摄像头/硬盘录像机的用户名
					password: 'luster123', //海康威视摄像头/硬盘录像机的密码
					channels: [], //海康威视摄像头/硬盘录像机的通道
				},
				loginStatus: false,
				checkView: false,
				winWidth: '100%',
				currentJT: '',
				fileId: '',
				mySelectWnd: 0, //当前选中的窗口
				g_bPTZAuto: false,
				iProtocol: 1,
				loginLoading: false,
				startPlayLoading: false,
				iStreamType: 1,
				bZeroChannel: false,
				iRtspPort: 0,
			}
		},
		watch: {
			fileId() {
				this.clickStopRealPlay()
				console.log('切换ip')
				// this.clickStopRealPlay()
				if (this.hkvInfo.ip) {
					this.onLogout()
					this.onLogin()
					console.log('id', this.hkvInfo.id)
					this.clickStartRealPlay()
				} else {
					this.$message({
						type: 'error',
						message: '没有摄像机ip，请添加',
					})
				}
				// if(this.checkView){
				//   this.clickStopRealPlay()
				// }
			},
		},

		created: function() {
			workshopRequest.queryAll().then(res => {
				console.log('获取车间', res)
				this.workshops = res
			})
			// this.onLogin()
		},
		mounted: function() {
			this.videoInitPlugin() // 初始化video界面
		},

		destroyed: function() {
			this.clickStopRealPlay()
			this.onLogout()
		},
		computed: {
			winHeight() {
				var winHeightval = document.body.clientHeight - 500
				return winHeightval + 'px'
			},
		},
		methods: {
			handleSelectJT(jtInfo) {
				this.currentJT = jtInfo
				console.log('jt_infeo', jtInfo)
				this.hkvInfo.ip = jtInfo.url //切换Url使得 机台发生改变
				// this.loginPassword=jtInfo.password,  //这些字段需要数据库添加
				// this.loginUser = user
				this.showDeviceInfo = true
				this.fileId = this.currentJT._id
			},
			onLogin() {
				var that = this
				that.loginLoading = true

				// 登录设备
				WebVideoCtrl.I_Login(that.hkvInfo.ip, that.iProtocol, that.hkvInfo.port, that.hkvInfo.username, that.hkvInfo.password, {
					async: false,
					success: function(xmlDoc) {
						// console.log('xmlDoc2', xmlDoc);//不能删除
						//TODO 获取通道信息
						that.getChannelInfo()
						that.getDevicePort(that.hkvInfo.ip + '_' + that.hkvInfo.port)
						that.loginLoading = false

						// that.$message({
						//   showClose: true,
						//   message: '登录成功',
						//   type: 'success'
						// });
						this.loginStatus = false

						this.loginStatus = true
					},
					error: function() {
						that.loginLoading = false
						that.$message({
							showClose: true,
							message: '登录失败',
							type: 'error',
						})
					},
				})
			},
			onLogout() {
				this.hkvInfo.channels = []
				var szDeviceIdentify = this.hkvInfo.ip + '_' + this.hkvInfo.port
				var iRet = WebVideoCtrl.I_Logout(szDeviceIdentify)
				if (0 == iRet) {
					console.log('退出成功')
					// this.$message({
					//   showClose: true,
					//   message: '退出成功',
					//   type: 'success'
					// });
				} else {
					// this.$message({
					//   showClose: true,
					//   message: '退出失败',
					//   type: 'error'
					// });
					console.log('退出失败')
				}
			},
			clickStartRealPlay() {
				// 开始预览
				var that = this
				that.startPlayLoading = true
				var szDeviceIdentify = that.hkvInfo.ip + '_' + that.hkvInfo.port

				var j = that.hkvInfo.channels.length > 4 ? 4 : that.hkvInfo.channels.length
				for (var i = 0; i < j; i++) {
					setTimeout(that.startRealPlay(szDeviceIdentify, i, that.hkvInfo.channels[i]), 500)
				}
				that.startPlayLoading = false
			},
			videoInitPlugin: function() {
				var iRet = WebVideoCtrl.I_CheckPluginInstall()
				if (iRet === -1) {
					alert('您还未安装过插件，双击开发包目录里的WebComponentsKit.exe安装')
					return
				}
				this.initPlugin()
			},
			initPlugin: function() {
				var that = this

				WebVideoCtrl.I_InitPlugin(500, 300, {
					bWndFull: true, //是否支持单窗口双击全屏，默I_CheckPluginInstall
					iWndowType: 1,
					myCbSelWnd: function(xmlStr) {
						//自己新增的方法
						var jsonObj = that.$x2js.xml2js(xmlStr)
						that.mySelectWnd = jsonObj.RealPlayInfo.SelectWnd
						var szInfo = '当前选择的窗口编号：' + that.mySelectWnd
						console.log(szInfo)
					},
					cbInitPluginComplete: function() {
						WebVideoCtrl.I_InsertOBJECTPlugin('divPlugin')
						// 检查插件是否最新
						if (WebVideoCtrl.I_CheckPluginVersion() === -1) {
							alert('检测到新的插件版本，双击开发包目录里的WebComponentsKit.exe升级！')
							return
						}
					},
				})
			},
			getDevicePort: function(szDeviceIdentify) {
				var oPort = WebVideoCtrl.I_GetDevicePort(szDeviceIdentify)
				this.iRtspPort = oPort.iRtspPort
			},
			startRealPlay: function(szDeviceIdentify, iWndIndex, iChannelID) {
				var that = this
				WebVideoCtrl.I_StartRealPlay(szDeviceIdentify, {
					iRtspPort: that.iRtspPort,
					iWndIndex: iWndIndex,
					iStreamType: 1,
					iChannelID: iChannelID,
					bZeroChannel: that.bZeroChannel,
					success: function() {
						that.$notify({
							title: '成功',
							message: '开始预览通道' + iChannelID + '成功',
							type: 'success',
						})
						this.checkView = true
					},
					error: function(status, xmlDoc2) {
						console.log(xmlDoc2) //不能删除
						that.$notify({
							title: '失败',
							message: '开始预览通道' + iChannelID + '失败',
							type: 'error',
						})
						if (status === 403) {
							console.log('szInfo 设备不支持Websocket取流！')
						} else {
							console.log('开始预览失败 ', status, xmlDoc2)
						}
					},
				})
			},
			clickStopRealPlay: function() {
				var j = this.hkvInfo.channels.length > 4 ? 4 : this.hkvInfo.channels.length
				for (var i = 0; i < j; i++) {
					setTimeout(this.stopRealPlay(i), 1000)
				}
			},
			stopRealPlay: function(iWndIndex) {
				var that = this
				WebVideoCtrl.I_Stop({
					iWndIndex: iWndIndex,
					success: function() {
						that.$notify({
							title: '成功',
							message: '停止预览窗口' + iWndIndex + '成功',
							type: 'success',
						})
						this.checkView = false
					},
					error: function() {
						console.log('停止预览失败')
						// that.$notify({
						//   title: '失败',
						//   message: '停止预览窗口' + iWndIndex + '失败',
						//   type: 'error'
						// });
					},
				})
			},
			// 获取通道，实际上可以根据自己的项目，获取数字通道，模拟通道，零通道中的一个或多个，不用全部获取（提高效率）
			getChannelInfo: function() {
				var that = this
				var szDeviceIdentify = this.hkvInfo.ip + '_' + this.hkvInfo.port
				// debugger
				// 数字通道
				that.hkvInfo.channels = []
				WebVideoCtrl.I_GetDigitalChannelInfo(szDeviceIdentify, {
					async: false,
					mysuccess: function(xmlStr) {
						console.log('mysuccess I_GetDigitalChannelInfo: ', xmlStr)
						var jsonObj = that.$x2js.xml2js(xmlStr)
						var list = jsonObj.InputProxyChannelStatusList.InputProxyChannelStatus
						for (var x = 0; x < list.length; x++) {
							that.hkvInfo.channels.push(list[x].id)
						}
					},
					success: function(xmlDoc) {},
					error: function(status, xmlDoc) {
						console.log('获取数字通道失败')
					},
				})
				// TODO 模拟通道
				// 模拟通道
				WebVideoCtrl.I_GetAnalogChannelInfo(szDeviceIdentify, {
					async: false,
					mysuccess: function(xmlStr) {
						var jsonObj = that.$x2js.xml2js(xmlStr)
						console.log('模拟通道mysuccess', xmlStr)
						// var list = jsonObj.VideoInputChannelList;
						// for (var x = 0; x < list.length; x++) {
						//   that.hkvInfo.channels.push(list[x].VideoInputChannel.id);
						// }
						var id = jsonObj.VideoInputChannelList.VideoInputChannel.id
						that.hkvInfo.channels.push(id)
					},
					success: function(xmlStr) {
						console.log('模拟通道success', xmlStr)
					},
					error: function(status, xmlDoc) {
						console.log('模拟通道error', xmlDoc)
					},
				})
				// TODO 零通道
			},
			mouseDownPTZControl: function(iPTZIndex) {
				var oWndInfo = WebVideoCtrl.I_GetWindowStatus(this.mySelectWnd)
				var iPTZSpeed
				if (oWndInfo !== null) {
					if (iPTZIndex === 9 && this.g_bPTZAuto) {
						iPTZSpeed = 0
					} else {
						this.g_bPTZAuto = false
					}

					WebVideoCtrl.I_PTZControl(iPTZIndex, false, {
						iPTZSpeed: 4,
						mysuccess: function(xmlStr) {
							console.log('I_PTZControl', xmlStr)
							if (iPTZIndex === 9 && this.g_bPTZAuto) {
								console.log(oWndInfo.szDeviceIdentify + ' 停止云台成功！mouseDown')
							} else {
								console.log(oWndInfo.szDeviceIdentify + ' 开启云台成功！mouseDown')
							}
							if (iPTZIndex === 9) {
								this.g_bPTZAuto = !this.g_bPTZAuto
							}
						},
						error: function(status, xmlDoc) {
							console.log(oWndInfo.szDeviceIdentify + ' 开启云台失败！mouseDown', status, xmlDoc)
						},
					})
				}
			},
			mouseUpPTZControl: function() {
				var oWndInfo = WebVideoCtrl.I_GetWindowStatus(this.mySelectWnd)
				if (oWndInfo !== null) {
					WebVideoCtrl.I_PTZControl(1, true, {
						mysuccess: function(xmlStr) {
							console.log(oWndInfo.szDeviceIdentify + ' 停止云台成功！mouseUp', xmlStr)
						},
						error: function(status, xmlDoc) {
							console.log(oWndInfo.szDeviceIdentify + ' 停止云台失败！mouseUp', status, xmlDoc)
						},
					})
				}
			},
		},
	}
</script>

<style scoped>
	.plugin {
		width: 100%;
		height: 300px;
	}

	.my-tag {
		margin-left: 3px;
	}

	.my-group-btn {
		margin-top: 5px;
	}
</style>
